import { useState } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Header from './components/layout/Header'
import Footer from './components/layout/Footer'
import ReserveModal from './components/modal/ReserveModal'
import HomePage from './pages/HomePage'
import ModelsPage from './pages/ModelsPage'
import usePageTracking from './hooks/usePageTracking'

function PageTracker() {
  usePageTracking()
  return null
}

export default function App() {
  const [reportedBurn, setReportedBurn] = useState(null)

  return (
    <BrowserRouter>
      <PageTracker />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage onBurnChange={setReportedBurn} />} />
        <Route path="/models" element={<ModelsPage />} />
      </Routes>
      <Footer />
      <ReserveModal reportedBurn={reportedBurn} />
    </BrowserRouter>
  )
}
